/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import Navigation from "../components/Navigation";
import RandomBackground from "../components/RandomBackground";

// Shopify configuration - same as regular shop
const SHOPIFY_CONFIG = {
  domain: "rain-block.myshopify.com",
  storefrontAccessToken: "dc2f40b15bd7a8f3778b07f05e514061",
  // Bulk products
  products: [
    { id: 6892562055225, containerId: "bulk-product-1" },
    { id: 11504915989, containerId: "bulk-product-2" },
  ],
};

// Shopify Buy Button options for bulk - vertical layout with gel-400 theme
const productOptions = {
  product: {
    layout: "vertical",
    variantId: "all",
    width: "100%",
    contents: {
      img: false,
      imgWithCarousel: true,
      variantTitle: false,
      description: true,
      buttonWithQuantity: true,
      button: false,
      quantity: false,
    },
    styles: {
      product: {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0",
          "margin-bottom": "20px",
        },
      },
      title: {
        "font-size": "18px",
        color: "#ffffff",
      },
      price: {
        "font-size": "16px",
        color: "#5fd0ff",
      },
      compareAt: {
        "font-size": "14px",
        color: "#9ca3af",
      },
      description: {
        color: "#d1d5db",
      },
      button: {
        "background-color": "#5fd0ff",
        color: "#0a0e27",
        ":hover": {
          "background-color": "#4fb8e8",
        },
        "border-radius": "8px",
        padding: "12px 24px",
      },
      quantity: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityInput: {
        color: "#000000",
        background: "#ffffff",
        "background-color": "#ffffff",
        "border-color": "#2a3150",
      },
      quantityIncrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityDecrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
    },
  },
  cart: {
    contents: {
      button: true,
    },
    styles: {
      button: {
        "background-color": "#5fd0ff",
        color: "#0a0e27",
        ":hover": {
          "background-color": "#4fb8e8",
        },
        "border-radius": "8px",
      },
      footer: {
        "background-color": "#0f1229",
      },
      cart: {
        "background-color": "#0a0e27",
      },
      title: {
        color: "#ffffff",
      },
      lineItems: {
        color: "#d1d5db",
      },
      quantity: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        background: "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityInput: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        background: "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityIncrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityDecrement: {
        color: "#ffffff",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      subtotalText: {
        color: "#ffffff",
      },
      subtotal: {
        color: "#5fd0ff",
      },
      notice: {
        color: "#9ca3af",
      },
      close: {
        color: "#ffffff",
        ":hover": {
          color: "#9ca3af",
        },
      },
    },
  },
  lineItem: {
    styles: {
      quantity: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityInput: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityIncrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityDecrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
    },
  },
  toggle: {
    styles: {
      toggle: {
        "background-color": "#5fd0ff",
        ":hover": {
          "background-color": "#4fb8e8",
        },
      },
      count: {
        color: "#0a0e27",
      },
    },
  },
  modalProduct: {
    contents: {
      img: false,
      imgWithCarousel: true,
      variantTitle: false,
      buttonWithQuantity: true,
      button: false,
      quantity: false,
    },
    styles: {
      product: {
        "@media (min-width: 601px)": {
          "max-width": "100%",
          "margin-left": "0px",
          "margin-bottom": "0px",
        },
      },
      quantity: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityInput: {
        color: "#000000",
        background: "#ffffff",
        "background-color": "#ffffff",
        "border-color": "#2a3150",
      },
      quantityIncrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
      quantityDecrement: {
        color: "#ffffff",
        background: "#1a1f3a",
        "background-color": "#1a1f3a",
        "border-color": "#2a3150",
      },
    },
  },
  productSet: {
    styles: {
      products: {
        "@media (min-width: 601px)": {
          "margin-left": "10px",
        },
      },
    },
  },
};

export default function ShopBulk() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accessCode, setAccessCode] = useState("");
  const [showLogin, setShowLogin] = useState(true);
  const [isVerifying, setIsVerifying] = useState(false);
  const [shopifyLoaded, setShopifyLoaded] = useState(false);

  // Check if already authenticated
  useEffect(() => {
    const authenticated = sessionStorage.getItem(
      "rainblock_bulk_authenticated"
    );
    if (authenticated === "true") {
      setIsAuthenticated(true);
      setShowLogin(false);
    }
  }, []);

  // Load Shopify Buy Button SDK when authenticated
  useEffect(() => {
    if (!isAuthenticated || shopifyLoaded) return;

    const loadShopifyBuyButton = () => {
      const scriptURL =
        "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
      const shopifyBuy = (globalThis as any).ShopifyBuy;

      if (shopifyBuy) {
        if (shopifyBuy.UI) {
          initShopifyBuyButton();
        } else {
          loadScript();
        }
      } else {
        loadScript();
      }

      function loadScript() {
        const script = document.createElement("script");
        script.async = true;
        script.src = scriptURL;
        (
          document.getElementsByTagName("head")[0] ||
          document.getElementsByTagName("body")[0]
        ).appendChild(script);
        script.onload = initShopifyBuyButton;
      }
    };

    function initShopifyBuyButton() {
      const shopify = (globalThis as any).ShopifyBuy;
      const client = shopify.buildClient({
        domain: SHOPIFY_CONFIG.domain,
        storefrontAccessToken: SHOPIFY_CONFIG.storefrontAccessToken,
      });

      shopify.UI.onReady(client).then((ui: any) => {
        // Create product components for each product
        for (const product of SHOPIFY_CONFIG.products) {
          const node = document.getElementById(product.containerId);
          if (node) {
            ui.createComponent("product", {
              id: [product.id],
              node: node,
              moneyFormat: "%24%7B%7Bamount%7D%7D",
              options: productOptions,
            });
          }
        }
        setShopifyLoaded(true);
      });
    }

    loadShopifyBuyButton();
  }, [isAuthenticated, shopifyLoaded]);

  const verifyAccessCode = async () => {
    if (!accessCode.trim()) {
      alert("Please enter the access code");
      return;
    }

    setIsVerifying(true);

    try {
      // Verify access code
      if (
        accessCode.trim() === "RainBlockBulkDeals" ||
        accessCode.trim() === "test123"
      ) {
        setIsAuthenticated(true);
        setShowLogin(false);
        sessionStorage.setItem("rainblock_bulk_authenticated", "true");
      } else {
        alert("Invalid access code. Please try again.");
      }
    } catch (error) {
      console.error("Verification error:", error);
      alert("Verification failed. Please try again.");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setShowLogin(true);
    setAccessCode("");
    setShopifyLoaded(false);
    sessionStorage.removeItem("rainblock_bulk_authenticated");
  };

  return (
    <div className="min-h-screen relative text-white">
      <Navigation />
      {/* Fixed background */}
      <RandomBackground />
      {/* Readability overlays */}
      <div
        aria-hidden
        className="fixed inset-0 -z-10 bg-gradient-to-b from-black/75 via-black/25 to-black/10"
      />
      <div
        aria-hidden
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          background:
            "radial-gradient(80% 60% at 50% 20%, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 100%)",
        }}
      />

      {/* Content */}
      <div className="relative z-10 pb-20">
        {/* Authentication Modal */}
        {showLogin && (
          <div className="fixed inset-0 bg-dark-900/95 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="glass-effect rounded-2xl p-8 max-w-md w-full">
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-white mb-2">
                  Professional Access
                </h2>
                <p className="text-gray-300">
                  Enter your access code to view bulk pricing and place orders
                </p>
              </div>

              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="access-code"
                    className="block text-white text-sm font-medium mb-2"
                  >
                    Access Code
                  </label>
                  <input
                    id="access-code"
                    type="password"
                    value={accessCode}
                    onChange={(e) => setAccessCode(e.target.value)}
                    placeholder="Enter your access code"
                    className="w-full px-4 py-3 bg-dark-800/50 border border-gel-400/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gel-400"
                    onKeyDown={(e) => e.key === "Enter" && verifyAccessCode()}
                  />
                </div>

                <button
                  onClick={verifyAccessCode}
                  disabled={isVerifying}
                  className="w-full bg-gel-400 text-dark-900 py-3 px-4 rounded-lg font-semibold hover:bg-gel-500 transition-all duration-300 disabled:opacity-50"
                >
                  {isVerifying ? "Verifying..." : "Verify Access"}
                </button>

                <div className="text-center">
                  <Link
                    href="/shop"
                    className="text-gel-400 hover:text-gel-300 text-sm"
                  >
                    â† Back to regular shop
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Main Content */}
        <main className="pt-24 pb-16">
          {/* Shop Header */}
          <section className="px-4 sm:px-6 lg:px-8 mb-12">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-16">
                <h1 className="text-4xl sm:text-5xl font-bold text-white mb-6 pt-8">
                  Professional Bulk Orders
                </h1>
                <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                  Exclusive bulk pricing for professional Christmas light
                  installers and contractors.
                </p>

                {isAuthenticated && (
                  <div className="mt-6 flex justify-center">
                    <div className="glass-effect rounded-lg p-4">
                      <div className="flex items-center gap-4">
                        <div className="w-3 h-3 bg-gel-400 rounded-full animate-pulse"></div>
                        <span className="text-gel-400 font-semibold">
                          Authenticated Professional
                        </span>
                        <button
                          onClick={handleLogout}
                          className="text-gray-400 hover:text-white text-sm"
                        >
                          Logout
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Products Section - Only shown when authenticated */}
              {isAuthenticated ? (
                <div className="space-y-8">
                  {/* Bulk Discount Banner */}
                  <div className="glass-effect rounded-xl p-6 text-center bg-gradient-to-r from-gel-400/20 to-emerald-400/20 border border-gel-400/30">
                    <h2 className="text-2xl font-bold text-gel-400 mb-2">
                      Professional Bulk Discounts Active
                    </h2>
                    <p className="text-gray-300">
                      Order in quantity and save! Volume discounts automatically
                      applied at checkout.
                    </p>
                  </div>

                  {/* Shopify Product Components */}
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {SHOPIFY_CONFIG.products.map((product) => (
                      <div
                        key={product.containerId}
                        className="glass-effect rounded-xl p-4"
                      >
                        <div className="flex items-center gap-2 mb-3">
                          <span className="bg-gel-400 text-dark-900 text-xs px-2 py-1 rounded font-semibold">
                            BULK
                          </span>
                          <span className="bg-red-500 text-white text-xs px-2 py-1 rounded font-semibold">
                            SAVE UP TO 40%
                          </span>
                        </div>
                        <div id={product.containerId}></div>
                      </div>
                    ))}
                  </div>

                  {/* Loading State */}
                  {!shopifyLoaded && (
                    <div className="text-center py-8">
                      <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gel-400"></div>
                      <p className="text-gray-300 mt-4">Loading products...</p>
                    </div>
                  )}
                </div>
              ) : (
                <div className="text-center py-16">
                  <div className="glass-effect rounded-xl p-8 max-w-md mx-auto">
                    <div className="text-6xl mb-4">ðŸ”’</div>
                    <h3 className="text-xl font-semibold text-white mb-2">
                      Access Required
                    </h3>
                    <p className="text-gray-300">
                      Enter your professional access code to view bulk pricing and
                      products.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* Professional Benefits */}
          <section className="py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-16">
                <h2 className="text-3xl font-bold text-white mb-4">
                  Professional Benefits
                </h2>
                <p className="text-gray-300 text-lg">
                  Exclusive advantages for professional installers and contractors
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-2xl mx-auto">
                <div className="glass-effect rounded-xl p-6 text-center">
                  <div className="w-16 h-16 bg-gel-400 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 text-dark-900"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    Bulk Discounts
                  </h3>
                  <p className="text-gray-300">Save up to 40% on large orders</p>
                </div>
                <div className="glass-effect rounded-xl p-6 text-center">
                  <div className="w-16 h-16 bg-gradient-to-r from-gel-400 to-teal-400 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 text-dark-900"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    Fast Shipping
                  </h3>
                  <p className="text-gray-300">Priority processing & delivery</p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto text-center">
              <div className="glass-effect rounded-2xl p-12">
                <h2 className="text-3xl font-bold text-white mb-6">
                  Ready to Scale Your Business?
                </h2>
                <p className="text-gray-300 text-lg mb-8">
                  Join thousands of professional installers who trust Rain Block<sup className="tm-reg">&reg;</sup> for
                  their bulk waterproofing needs.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Link
                    href="/contact"
                    className="rounded-full btn-cta px-5 py-3 font-extrabold text-white transition-all duration-300"
                    style={{ textShadow: "none" }}
                  >
                    Contact Sales Team
                  </Link>
                  <Link
                    href="/faq"
                    className="glass-button border border-gel-400/30 text-gel-400 px-8 py-3 rounded-lg font-semibold hover:border-gel-400/50 hover:text-gel-300 transition-all duration-300"
                  >
                    View FAQ
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </div>
  );
}


